/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { ApiYAxisChartTypeFromJSON, ApiYAxisChartTypeToJSON, } from './ApiYAxisChartType';
export function ApiChartYAxisKeyFromJSON(json) {
    return ApiChartYAxisKeyFromJSONTyped(json, false);
}
export function ApiChartYAxisKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : (mapValues(json['chart'], ApiYAxisChartTypeFromJSON)),
        'fields': !exists(json, 'fields') ? undefined : json['fields'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'stackId': !exists(json, 'stackId') ? undefined : json['stackId'],
    };
}
export function ApiChartYAxisKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': value.chart === undefined ? undefined : (mapValues(value.chart, ApiYAxisChartTypeToJSON)),
        'fields': value.fields,
        'key': value.key,
        'stackId': value.stackId,
    };
}
